import { render, staticRenderFns } from "./MarginSelector.vue?vue&type=template&id=3aece20c&scoped=true"
import script from "./MarginSelector.vue?vue&type=script&lang=js"
export * from "./MarginSelector.vue?vue&type=script&lang=js"
import style0 from "./MarginSelector.vue?vue&type=style&index=0&id=3aece20c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aece20c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3aece20c')) {
      api.createRecord('3aece20c', component.options)
    } else {
      api.reload('3aece20c', component.options)
    }
    module.hot.accept("./MarginSelector.vue?vue&type=template&id=3aece20c&scoped=true", function () {
      api.rerender('3aece20c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chart/components/componentStyle/MarginSelector.vue"
export default component.exports